var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}draft`,"viewBox":"0 0 16 16"}},[_c('circle',{staticClass:"sign",attrs:{"cx":"8","cy":"8","r":"7","stroke-width":"2","stroke-dasharray":"2.9 2.6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }